import { render, staticRenderFns } from "./StatsComplaints.vue?vue&type=template&id=0b44d154&"
import script from "./StatsComplaints.vue?vue&type=script&lang=js&"
export * from "./StatsComplaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports